import type { AnalyticsPeriod, DateRange } from '@/api/hooks/useAnalytics';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const CHIPS: Array<{ value: AnalyticsPeriod; label: string }> = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
  { value: '180d', label: '6 months' },
  { value: '365d', label: '1 year' },
];

export function PeriodSelector({
  period,
  range,
  onPeriodChange,
  onRangeChange,
}: {
  period: AnalyticsPeriod;
  range: DateRange;
  onPeriodChange: (period: AnalyticsPeriod) => void;
  onRangeChange: (range: DateRange) => void;
}) {
  const isCustom = Boolean(range.from || range.to);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex flex-wrap gap-1.5">
        {CHIPS.map((chip) => (
          <button
            key={chip.value}
            type="button"
            onClick={() => {
              onRangeChange({});
              onPeriodChange(chip.value);
            }}
            className={cn(
              'rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
              period === chip.value && !isCustom
                ? 'bg-primary text-primary-foreground'
                : 'bg-secondary text-secondary-foreground hover:bg-secondary/70',
            )}
          >
            {chip.label}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <span className="font-medium">Custom:</span>
        <Input
          type="date"
          value={range.from ?? ''}
          onChange={(e) => onRangeChange({ ...range, from: e.target.value || undefined })}
          className="h-8 w-36"
        />
        <span>→</span>
        <Input
          type="date"
          value={range.to ?? ''}
          onChange={(e) => onRangeChange({ ...range, to: e.target.value || undefined })}
          className="h-8 w-36"
        />
      </div>
    </div>
  );
}